import type { ToolbarProps } from 'react-big-calendar';
import { createContext, useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import styles from './CalendarToolbar.module.scss';

import { SimpleEvent } from 'api/dtos/event';

export const CalendarToolbarDisabledContext = createContext(false);

type Props = ToolbarProps<SimpleEvent> & {
    disabled?: boolean;
};

const CalendarToolbar = ({
    label,
    onNavigate,
    onView,
    view,
    disabled,
}: Props) => {
    const intl = useIntl();
    const contextDisabled = useContext(CalendarToolbarDisabledContext);
    const isDisabled = disabled ?? contextDisabled;

    return (
        <div className={styles.toolbar}>
            <div className={styles.toolbarGroup}>
                <button type="button" onClick={() => onNavigate('TODAY')} disabled={isDisabled}>
                    {intl.formatMessage(messages.today)}
                </button>
                <button type="button" onClick={() => onNavigate('PREV')} disabled={isDisabled}>
                    {intl.formatMessage(messages.previous)}
                </button>
                <button type="button" onClick={() => onNavigate('NEXT')} disabled={isDisabled}>
                    {intl.formatMessage(messages.next)}
                </button>
            </div>
            <span className={styles.toolbarLabel}>{label}</span>
            <div className={styles.toolbarGroup}>
                <button
                    type="button"
                    className={view === 'month' ? styles.activeToolbarButton : undefined}
                    onClick={() => onView('month')}
                    disabled={isDisabled}
                >
                    {intl.formatMessage(messages.month)}
                </button>
                <button
                    type="button"
                    className={view === 'week' ? styles.activeToolbarButton : undefined}
                    onClick={() => onView('week')}
                    disabled={isDisabled}
                >
                    {intl.formatMessage(messages.week)}
                </button>
                <button
                    type="button"
                    className={view === 'day' ? styles.activeToolbarButton : undefined}
                    onClick={() => onView('day')}
                    disabled={isDisabled}
                >
                    {intl.formatMessage(messages.day)}
                </button>
            </div>
        </div>
    );
};

const messages = defineMessages({
    today: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.today',
        defaultMessage: 'Dzisiaj',
    },
    previous: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.previous',
        defaultMessage: 'Poprzedni',
    },
    next: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.next',
        defaultMessage: 'Następny',
    },
    month: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.month',
        defaultMessage: 'Miesiąc',
    },
    week: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.week',
        defaultMessage: 'Tydzień',
    },
    day: {
        id: 'src.Screens.Dashboard.Events.CalendarToolbar.day',
        defaultMessage: 'Dzień',
    },
});

export default CalendarToolbar;
